import { render, staticRenderFns } from "./b-menu-drop-target.vue?vue&type=template&id=70ce2e95&scoped=true&"
import script from "./b-menu-drop-target.vue?vue&type=script&lang=js&"
export * from "./b-menu-drop-target.vue?vue&type=script&lang=js&"
import style0 from "./b-menu-drop-target.vue?vue&type=style&index=0&id=70ce2e95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ce2e95",
  null
  
)

export default component.exports